import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";
import { button, buttonReset, colors, font } from "../../lib/sharedStyles";
import { X } from "@fenderdigital/ui/Icons";
import PLPFilterList from "./PLPFilterList";
import PLPActiveFilters from "./PLPActiveFilters";

const Container = styled.div`
  @media (min-width: 1024px) {
    display: none;
  }
`;

const Overlay = styled.div<{ $panelOpen: boolean; }>`
  position: fixed;
  z-index: 12;
  top: 0;
  height: 100vh;
  width: 100%;
  opacity: 0;
  pointer-events: none;
  background: ${colors.fender.primaryDark};

  ${({ $panelOpen }) => $panelOpen && `
    opacity: 0.5;
    pointer-events: initial;
  `}
`;

const Panel = styled.div<{ $isOpen: boolean; }>`
  position: fixed;
  z-index: 13;
  bottom: 0;
  height: 90vh;
  width: 100vw;
  transform: translateY(91vh);
  transition: transform 250ms ease;

  ${({ $isOpen }) => $isOpen && `
    transform: translateY(0);
  `}
`;

const PanelHeader = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: ${colors.fender.white};
  
  p {
    ${font('Instrument Sans', 600, '16px', '22px')}
    letter-spacing: 0.16px;
    color: ${colors.fender.black};
    margin: 0;
  }

  button {
    ${buttonReset()}
  }
`;

const PanelContent = styled.div`
  background-color: ${colors.fender.white};
  padding: 0 16px;
  overflow: scroll;
  // 70px = PanelHeader height
  height: calc(100% - 70px);
  margin-top: 70px;
`;

const ResultsButton = styled.div`
  position: fixed;
  z-index: 14;
  bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: center;

  button {
    ${button('Black Pill', 'fender', true)};
    border: none;
    padding: 10 24px;
    ${font('Instrument Sans', 600, '16px', '22px')}
    letter-spacing: 0.16px;
  }
`;

const AppliedFilters = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid ${colors.fender.grey03};

  > p {
    ${font('Instrument Sans', 600, '16px', '22px')};
    letter-spacing: 0.16px;
    color: #000;
  }
`;

const PLPFilterMobile = () => {
  const { activeFilters, filterMenuOpen, toggleFilterMenu, pagination } = useSearchspringPLPContext();

  return (
    <Container>
      <Overlay 
        onClick={toggleFilterMenu}
        $panelOpen={filterMenuOpen} 
      />
      <Panel $isOpen={filterMenuOpen}>
        <PanelHeader>
          <p>Filter & Sort</p>
          <button onClick={toggleFilterMenu}>
            <X fontSize="12px" />
          </button>
        </PanelHeader>
        <PanelContent>
          {(activeFilters.length > 0) && (
            <AppliedFilters>
              <p>Applied Filters</p>
              <PLPActiveFilters />
            </AppliedFilters>
          )}
          <PLPFilterList />
        </PanelContent>
        <ResultsButton>
          <button onClick={() => toggleFilterMenu()}>
            Show {pagination.totalResults} results
          </button>
        </ResultsButton>
      </Panel>
    </Container>
  );
}

export default PLPFilterMobile;